import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORMMediator } from 'utility-ts-datasource';
import { APMultiTerm } from '../../global/builders/ap_multi_term_builder';
import { IAPMultiTermDatasource } from '../../global/datasources/ap_multi_student_term_datasource';
import { IAPPlannedCourse } from '../../global/helpers/ap_multi_plan_helper';
import { APCourseStatusStrategy } from '../../global/strategies/ap_course_status_strategy';

export class APMultiTermsQuery implements IQuery {
  private __result: {};

  constructor(private ngAPMultiTermDatasource: IAPMultiTermDatasource) {
    ORMMediator.registerQuery(this, ngAPMultiTermDatasource);
  }
  run(): this {
    const terms = _4.orderBy(this.ngAPMultiTermDatasource.values(), ['rank', 'name']);
    _4.each(terms, (term: APMultiTerm) => {
      _4.map(term.plannedCourses, (plannedcourse: IAPPlannedCourse) => {
        plannedcourse['courses'] = [...plannedcourse.slot_courses];
      });
      term['courses'] = [...term.plannedCourses, ...term.plannedCourseGroups];

      const coursesGroupedByStatus = _4.groupBy([...term.plannedCourses, ...term.plannedCourseGroups], 'status');
      term['statusGroups'] = _4.map(coursesGroupedByStatus, (courses, statusGroup: string) => ({
        status: _4.get(APCourseStatusStrategy.getByKey(statusGroup), 'humanString', 'Planned'),
        courses
      }));
    });
    const completedTerms = _4.filter(terms, ['isCompleted', true]);
    const currentTerms = _4.filter(terms, ['isCompleted', false]);
    const termsInfo = _4.map(currentTerms, (term: APMultiTerm) => {
      return {
        id: term.termId,
        name: term.name
      };
    });
    this.__result = {
      termsInfo,
      completedTerms,
      currentTerms,
      terms
    };
    return this;
  }

  get result() {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPMultiTermsQuery', APMultiTermsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/queries/ap_mm_terms_query.ts